<template>
    <div class="anatomia-panel">
        <section class="anatomia-panel__header">
            <panelTitle>Estruturas anatômicas</panelTitle>
        </section>
        <Divider />
        <div class="anatomia-panel__content">
            <section class="layer-item" v-for="layer in layerChildren" :key="layer.id" :data-focused="focusedLayer == layer.id">
                <div class="layer-item__header" @click="toggleLayerFocus(layer)">
                    <CircleCheckIconSvg class="icon" />
                    <span class="title">{{ layer.layout.caption }}</span>
                </div>
                <div class="layer-item__content">
                    <div class="label-item" v-for="label in getLabelChildren(layer)" :key="label.id"
                        @mouseover="onHoverLabelItem(label)" @mouseleave="onLeaveLabelItem(label)">
                        <div v-if="label.layout.color" class="label-item__color" :style="{
                            background: getLabelColor(label),
                        }">
                        </div>
                        <span class="label-item__title">
                            {{ label.layout.caption }}
                        </span>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { gConsts } from '@/globals/gConsts';
import { evtBus } from '@/main';
import CircleCheckIconSvg from '@/assets/icons/circle-check.svg';
import panelTitle from '@/components/ui/panel/panelTitle.vue';
import Divider from '@/components/ui/divider.vue';

export default {
    name: 'anatomiaPanel',
    components: {
        CircleCheckIconSvg,
        panelTitle,
        Divider,
    },
    data() {
        return {
            gConsts: gConsts,
            focusedLayer: null,
        }
    },
    computed: {
        ...mapGetters([
            'GET_filteredNodes',
            'GET_jobTools',
        ]),

        layerChildren() {
            return this.GET_filteredNodes.filter(node => node.layout.parent === 'step_anatomia');
        }
    },
    methods: {
        getLabelChildren(layer) {
            return this.GET_filteredNodes.filter(node => {
                if (node.layout.parent !== layer.id)
                    return false;

                return this.GET_jobTools.some(tool => tool.label.id == node.id);
            });
        },
        
        toggleLayerFocus(layer) {
            this.focusedLayer = this.focusedLayer == layer.id ? null : layer.id;
            evtBus.$emit('evt_activateNode', { layer: this.focusedLayer, step: 'step_anatomia' });
        },

        onHoverLabelItem(label) {
            evtBus.$emit('evt_tool_displayLabel', { label: label.id });
        },

        onLeaveLabelItem(label) {
            evtBus.$emit('evt_tool_displayLabel', { label: null });
        },

        getLabelColor(label) {
            return gConsts.ui.prettyColors[label?.layout?.color?.toLowerCase()] || label?.layout?.color;
        },
    }
}
</script>

<style scoped>
.anatomia-panel {
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: var(--background-white);
}

.anatomia-panel__header,
.anatomia-panel__content {
    padding: var(--spacing) var(--spacing-sl);
}

.anatomia-panel__header {
    display: flex;
    align-items: center;
    gap: var(--spacing-sm);
}

.anatomia-panel__content {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-md);
    overflow-y: auto;
    height: 100%;
    max-height: calc(100vh - 200px);
    padding-block: var(--spacing-sl);
}

.layer-item {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xs);
    border-radius: var(--radius-md);
    border: 1px solid var(--border-primary);
    padding: var(--spacing);
}

.layer-item[data-focused="true"] {
    border-color: #2B536A99;
    box-shadow: 0 0 2px 0px #2B536A99;
}

.layer-item__header {
    display: flex;
    align-items: center;
    gap: var(--spacing-xs);
    width: min-content;
    cursor: pointer;
}

.layer-item__header:hover {
    opacity: 0.7;
}

.layer-item__header .icon {
    color: var(--color-primary);
    flex-shrink: 0;
    display: none;
}

.layer-item[data-focused="true"] .layer-item__header .icon {
    display: block;
}

.layer-item__header .title {
    font-family: var(--font-family-primary);
    font-weight: 600;
    font-size: var(--text-md);
    color: var(--color-secondary);
}

.layer-item__content {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-md);
    padding: var(--spacing-sm) 0;
}

.label-item {
    display: flex;
    align-items: center;
    gap: var(--spacing-xs);
    box-sizing: border-box;
    width: 100%;
    cursor: help;
}

.label-item__color {
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: var(--radius-sm);
    flex-shrink: 0;
}

.label-item__title {
    font-family: var(--font-family-primary);
    font-weight: 500;
    font-size: var(--text-sm);
    color: var(--color-primary);
    line-height: 1;
    text-align: left;
    transition: opacity 0.2s ease;
}

.label-item:hover {
    opacity: 0.7;
}

.label-item:hover .label-item__title {
    font-weight: 600;
}
</style>